import { ReportGroup } from '@/api/generatedApi';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List } from 'react-window';
import { ReportSample } from './ReportSample';
import { GroupSampleHeight } from './ReportSample.styles';
import { useSmoothScrollToItem } from '@/hooks/useSmoothScrollToItem';

export const ReportGroupsList = ({
  groups,
  selectedGroupId,
  isDragging,
}: {
  groups: ReportGroup[];
  selectedGroupId: string | undefined;
  isDragging?: boolean;
}) => {
  const { outerRef } = useSmoothScrollToItem({
    items: groups,
    selectedId: selectedGroupId,
    itemHeight: GroupSampleHeight,
    getItemId: group => group.id,
  });

  return (
    <AutoSizer>
      {({ height, width }) => (
        <List
          outerRef={outerRef}
          height={height}
          itemCount={groups.length}
          itemSize={GroupSampleHeight}
          width={width}
          itemData={groups}
        >
          {({ index, style }) => (
            <div style={style}>
              <ReportSample
                group={groups[index]}
                groupIndex={index + 1}
                isSelected={selectedGroupId === undefined ? false : groups[index].id === selectedGroupId}
                isLastItem={index === groups.length - 1}
                isDragging={isDragging}
              />
            </div>
          )}
        </List>
      )}
    </AutoSizer>
  );
};
